import * as _ from "lodash-es";
export class MarketplaceProjectCardDataModel {
    constructor(carbonProjectListItemWithMetadata, marketplaceOrderItems, isFavorite) {
        Object.defineProperty(this, "carbonProjectListItemWithMetadata", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "marketOrderItems", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isFavorite", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "priceFromCurrency", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "priceFromAmount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "priceToCurrency", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "priceToAmount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "totalVolume", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "vintageGroup", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.carbonProjectListItemWithMetadata = carbonProjectListItemWithMetadata;
        this.marketOrderItems = marketplaceOrderItems;
        this.isFavorite = isFavorite;
        const priceFrom = _.minBy(marketplaceOrderItems, x => x.Price?.Amount)?.Price;
        this.priceFromCurrency = priceFrom?.Currency;
        this.priceFromAmount = priceFrom?.Amount;
        const priceTo = _.maxBy(marketplaceOrderItems, x => x.Price?.Amount)?.Price;
        this.priceToCurrency = priceTo?.Currency;
        this.priceToAmount = priceTo?.Amount;
        this.totalVolume = _.sum(marketplaceOrderItems.map(x => x.Volume));
        const vintages = [...new Set(marketplaceOrderItems.map(x => x.VintageGroup.FromYear).concat(marketplaceOrderItems.map(x => x.VintageGroup.ToYear)))];
        const vintageFrom = _.min(vintages);
        const vintageTo = _.max(vintages);
        this.vintageGroup = {
            FromYear: vintageFrom,
            ToYear: vintageTo
        };
    }
}
